import {Suspense} from "react";
import {Helmet} from "react-helmet-async";
import {Navigate} from "react-router";

import {CheckoutContextProvider} from "@/components/context/CheckoutContext.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {CancelSubscriptionForm} from "@/pages/billing/cancel-subscription/CancelSubscriptionForm.tsx";

export const CancelSubscriptionPage = () => {
  const {user} = useCurrentUserContext();

  // this page should only be accessible to primary users
  if (!user?.is_primary) {
    return <Navigate to="/access-denied?type=owner" />;
  }
  return (
    <ContentContainer title="Did we miss the mark?">
      <Helmet>
        <title>Cancel Subscription</title>
      </Helmet>
      <Suspense fallback={<LoadingContainer text="Loading subscription data..." />}>
        <UpErrorBoundary>
          <CheckoutContextProvider>
            <CancelSubscriptionForm />
          </CheckoutContextProvider>
        </UpErrorBoundary>
      </Suspense>
    </ContentContainer>
  );
};
